export default __webpack_public_path__ + "static/media/b12.f55533ee.jpg";